import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminClients from "@/pages/admin/AdminClients";
import AdminPackages from "@/pages/admin/AdminPackages";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminProjectDetail from "@/pages/admin/AdminProjectDetail";
import AdminUsers from "@/pages/admin/AdminUsers";
import AdminAudit from "@/pages/admin/AdminAudit";
import AdminDemoRequests from "@/pages/admin/AdminDemoRequests";

import ClientLayout from "@/pages/client/ClientLayout";
import ClientDashboard from "@/pages/client/ClientDashboard";
import ClientProject from "@/pages/client/ClientProject";

import PublicViewer from "@/pages/viewer/PublicViewer";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />

      <Route path="/p/:slug" element={<PublicViewer />} />
      <Route path="/p/:slug/etap/:etapCode" element={<PublicViewer />} />
      <Route path="/embed/:slug" element={<PublicViewer embed />} />
      <Route path="/embed/:slug/etap/:etapCode" element={<PublicViewer embed />} />

      <Route
        path="/studio"
        element={
          <ProtectedRoute role="platform_admin">
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AdminDashboard />} />
        <Route path="clients" element={<AdminClients />} />
        <Route path="packages" element={<AdminPackages />} />
        <Route path="users" element={<AdminUsers />} />
        <Route path="projects" element={<AdminProjects />} />
        <Route path="projects/:pid" element={<AdminProjectDetail />} />
        <Route path="demo-requests" element={<AdminDemoRequests />} />
        <Route path="audit" element={<AdminAudit />} />
      </Route>

      <Route
        path="/portal"
        element={
          <ProtectedRoute>
            <ClientLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<ClientDashboard />} />
        <Route path="projects/:pid" element={<ClientProject />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
